// extracted by mini-css-extract-plugin
module.exports = {"bopPolicyRenewalWizardContainer":"BOPPolicyRenewalWizard_bopPolicyRenewalWizardContainer__BKgVr"};